/**
 * Geometry utilities for SVG and canvas rendering.
 */

/** Calculate circle circumference from radius. */
export function calculateCircumference(radius: number): number {
  return 2 * Math.PI * radius;
}

/** Calculate arc path for a circular progress indicator. */
export function arcPath(
  cx: number,
  cy: number,
  radius: number,
  startAngle: number,
  endAngle: number
): string {
  const start = polarToCartesian(cx, cy, radius, endAngle);
  const end = polarToCartesian(cx, cy, radius, startAngle);
  const largeArc = endAngle - startAngle <= 180 ? "0" : "1";
  return [
    `M ${start.x} ${start.y}`,
    `A ${radius} ${radius} 0 ${largeArc} 0 ${end.x} ${end.y}`,
  ].join(" ");
}

/** Convert polar coordinates to Cartesian. */
function polarToCartesian(cx: number, cy: number, r: number, angle: number) {
  const radians = (angle - 90) * Math.PI / 180;
  return {
    x: cx + r * Math.cos(radians),
    y: cy + r * Math.sin(radians),
  };
}
